import { useTranslation } from 'react-i18next';

import { LoadingSpinner, ScrollArea } from '@app/shared/ui/atoms/Common';
import { ActionsSection, UserInfoSection, WalletSection } from '@app/shared/ui/organisms/Diamonds';
import { useGetCurrentUserProfileQuery } from '@app/store/slices/users/usersApi';
import { useBalance } from '@app/shared/hooks/useBalance';
import { useDisplayError } from '@app/shared/hooks/useDisplayError';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { DIAMONDS_SHOP_PRELOAD_IMAGES } from '@app/assets';

export default function DiamondsPage() {
  const {
    data: user,
    isLoading: isUserLoading,
    isError: isUserError,
  } = useGetCurrentUserProfileQuery();
  const { tonBalance } = useBalance();
  const { t } = useTranslation();
  const isImagesLoading = usePreloadImages(DIAMONDS_SHOP_PRELOAD_IMAGES);

  useDisplayError(isUserError, t('errors.failed_to_load_user'));

  if (isImagesLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ScrollArea className="gap-6">
      <UserInfoSection
        userName={user?.fullName}
        avatar={user?.avatar}
        gender={user?.gender}
        tonBalance={tonBalance}
        isUserLoading={isUserLoading}
      />
      <WalletSection
        userName={user?.fullName}
        cardNumber="0282-9018-2918-8793"
        registrationDate={1682899200000}
      />
      <ActionsSection />
    </ScrollArea>
  );
}
